export const LOAD_EMPLOYEERECORDS_SUCCESS = "LOAD_EMPLOYEERECORDS_SUCCESS";

export const CREATE_EMPLOYEERECORD_SUCCESS = "CREATE_EMPLOYEERECORD_SUCCESS";

export const SAVE_EMPLOYEERECORD_SUCCESS = "SAVE_EMPLOYEERECORD_SUCCESS";

export const DELETE_EMPLOYEERECORD_SUCCESS = "DELETE_EMPLOYEERECORD_SUCCESS";

export const LOAD_EMPLOYEERECORD_DETAIL_SUCCESS = "LOAD_EMPLOYEERECORD_DETAIL_SUCCESS";

export const LOAD_ORGSTRUCTURES_SEARCH_SUCCESS_ONE = "LOAD_ORGSTRUCTURES_SEARCH_SUCCESS_ONE";

export const LOAD_ORGSTRUCTURES_SEARCH_SUCCESS_TWO = "LOAD_ORGSTRUCTURES_SEARCH_SUCCESS_TWO";

export const LOAD_ORGSTRUCTURES_SEARCH_SUCCESS_THREE = "LOAD_ORGSTRUCTURES_SEARCH_SUCCESS_THREE";

export const LOAD_ORGSTRUCTURES_SEARCH_SUCCESS_FOUR = "LOAD_ORGSTRUCTURES_SEARCH_SUCCESS_FOUR";

export const DEACTIVATE_EMPLOYEERECORD_SUCCESS = "DEACTIVATE_EMPLOYEERECORD_SUCCESS";

export const ACTIVATE_EMPLOYEERECORD_SUCCESS = "ACTIVATE_EMPLOYEERECORD_SUCCESS";

export const CREATE_EMPLOYEE_DOCUMENT_SUCCESS = "CREATE_EMPLOYEE_DOCUMENT_SUCCESS";

export const LOAD_EMPLOYEE_DOCUMENTS_SUCCESS = "LOAD_EMPLOYEE_DOCUMENTS_SUCCESS";

export const DELETE_EMPLOYEE_DOCUMENT_SUCCESS = "DELETE_EMPLOYEE_DOCUMENT_SUCCESS";

export const LOAD_EMPLOYEE_RECORD_DETAIL = "LOAD_EMPLOYEE_RECORD_DETAIL";

export const LOAD_EMPLOYEE_DOCUMENTS = "LOAD_EMPLOYEE_DOCUMENTS";

export const DELETE_EMPLOYEE_DOCUMENT = "DELETE_EMPLOYEE_DOCUMENT";

export const CREATE_EMPLOYEERECORD = "CREATE_EMPLOYEERECORD";

export const SAVE_EMPLOYEERECORD = "SAVE_EMPLOYEERECORD";

export const SAVE_EMPLOYEE_RECORD_FROM_OHCASE = "SAVE_EMPLOYEE_RECORD_FROM_OHCASE";

export const MERGE_EMPLOYEE_RECORD = "MERGE_EMPLOYEE_RECORD";

export const SET_CLOSE_MONITORING = "SET_CLOSE_MONITORING";

export const SET_CLOSE_MONITORING_SUCCESS = "SET_CLOSE_MONITORING_SUCCESS";
